import { createSlice } from "@reduxjs/toolkit"

const initState = {
  pageData: [],
  page: false,
  combobox: [],
  data: false,
  detail: {},
  assignTab: 0,
  calendar: undefined,
  calendarDetail: undefined,
  calendarList: undefined,
  detailCalendarLoading: false,
  role: [],
  availableMember: [],
  listParam: undefined,
  regionalHeadDetail: {},
  fieldManagerDetail: {},
  kpiGoalThisYearTargetRegional: undefined,
  kpiGoalInitDataEditSubRegional: undefined,
  targetSubregional: undefined,
  listFoBySubRegional: [],
  initForecast: [],
  loadingInitForecast: false,
  mitraListSelector: undefined,
  regionalHead: undefined
}

export const FieldOfficerSlice = createSlice({
  name: "fieldOfficer",
  initialState: initState,
  reducers: {
    getPage: (state, action) => {
      state.data = action.payload
    },
    setCombobox: (state, action) => {
      state.combobox = action.payload
    },
    setPageData: (state, action) => {
      const { pageData, page, param } = action.payload
      state.pageData = pageData
      state.page = page
      state.listParam = param
    },
    getDetail: (state, { payload }) => {
      state.detail = payload
    },
    getAssignTab: (state, { payload }) => {
      state.assignTab = payload
    },
    setAssignTab: (state, action) => {
      const { tab } = action.payload
      state.assignTab = tab
    },
    getRole: (state, { payload }) => {
      state.role = payload
    },
    getAvailableMember: (state, { payload }) => {
      state.availableMember = payload
    },
    getCalendar: (state, { payload }) => {
      state.calendar = payload
    },
    getCalendarDetail: (state, { payload }) => {
      state.calendarDetail = payload
    },
    getCalendarList: (state, { payload }) => {
      state.calendarList = payload
    },
    getDetailCalendarLoading: (state, { payload }) => {
      state.detailCalendarLoading = payload
    },
    setRegionalHeadDetail: (state, { payload }) => {
      state.regionalHeadDetail = payload
    },
    setFieldManagerDetail: (state, { payload }) => {
      state.fieldManagerDetail = payload
    },
    setKpiGoalThisYearTargetRegional: (state, { payload }) => {
      state.kpiGoalThisYearTargetRegional = payload
    },
    setkpiGoalInitDataEditSubRegionalTarget: (state, { payload }) => {
      state.kpiGoalInitDataEditSubRegional = payload
    },
    setTargetSubregional: (state, { payload }) => {
      state.targetSubregional = payload
    },
    listFoBySubRegional: (state, { payload }) => {
      state.listFoBySubRegional = payload?.page || []
    },
    listInitForecast: (state, { payload }) => {
      state.initForecast = payload.page || []
    },
    loadingInitForecast: (state, { payload }) => {
      state.loadingInitForecast = payload
    },
    setMitraListSelector: (state, { payload }) => {
      state.mitraListSelector = payload
    },
    clearMitraListSelector: (state) => {
      state.mitraListSelector = undefined
    },
    setRegionalHead: (state, { payload }) => {
      state.regionalHead = Array.isArray(payload) ? payload[0] : payload
    },
  }
})
